<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Solicitar Diligência de Julgamento</p>
    </header>
    <section class="modal-card-body">
      <p class="mb-3">
        Itens selecionados: <strong>{{ itemLabels }}</strong>
      </p>
      <b-field
        label="Orientações ao licitante"
        :type="invalid ? 'is-danger' : ''"
        :message="invalid ? 'Descrição é obrigatória' : ''"
      >
        <b-input
          v-model="description"
          type="textarea"
          rows="5"
          maxlength="4000"
          placeholder="Descreva os documentos complementares solicitados"
        />
      </b-field>
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <button class="button" type="button" @click="$emit('close')">Cancelar</button>
      <button
        class="button is-primary"
        type="button"
        :class="{ 'is-loading': loading }"
        @click="submit"
      >
        Solicitar
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'JudgmentDiligenceRequestModal',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      description: '',
      invalid: false,
    };
  },
  computed: {
    itemLabels() {
      return this.items.map(item => item.identificador).join(', ');
    },
  },
  methods: {
    submit() {
      if (!this.description.trim()) {
        this.invalid = true;
        return;
      }
      this.invalid = false;
      this.$emit('submit', this.description.trim());
    },
  },
};
</script>
